export default "__VITE_ASSET__ByCmAqyX__"